import React from "react";
import { Container, Dropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import swal from "sweetalert";
import { useGlobalValues } from "../context/globalValues";
import { useShellUI } from "../context/shellUI";
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useGlobalValues();
  const { openMobile } = useShellUI();

  const isActive = (path) => location.pathname === path;
  const initials = (userDetails?.email || "A").trim().charAt(0).toUpperCase();

  return (
    <>
      <div className="admin-header">
        <Container fluid>
          <div className="admin-header-inner">
            <div className="header-spacer" />
            <div className="header-right">
            <div className="logout-btn">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <span className="header-avatar" aria-hidden="true">{initials}</span>
                  <span className="user-meta">
                    <span className="user-name">{userDetails?.email || "Admin"}</span>
                    <span className="user-role">Admin</span>
                  </span>
                  <svg className="header-avatar-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  <div className="dropdown-user-info">
                    <span className="dropdown-user-email">{userDetails?.email || "Admin"}</span>
                    <span className="dropdown-user-role">Admin</span>
                  </div>
                  <Dropdown.Divider />
                <Dropdown.Item
                    className={isActive("/ChangePassword") ? "header-dropdown-active" : ""}
                    onClick={()=>{navigate("/ChangePassword")}}
                  >
                    <i className="fa fa-lock" aria-hidden="true"></i>
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="dropdown-item-danger"
                   onClick={()=>{
                    swal({
                      title: 'Are you sure?',
                      text: 'You want to proceed with the logout?',
                      icon: 'warning',
                      buttons: ['Cancel', 'Yes, logout'],
                      dangerMode: true,
                    }).then((confirmed) => {
                      if (confirmed) {

                        localStorage.clear();
                        navigate("/");

                      }
                    })
                   }}

                  >
                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                    Sign Out
                  </Dropdown.Item>

                </Dropdown.Menu>
              </Dropdown>
            </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};
export default Header;

